export default {
    getHeaderFieldsEprofileKorabbiMutet: state => state.headerFieldsEprofileKorabbiMutet,
    getFormActionsEprofileKorabbiMutet: state => state.formActionsEprofileKorabbiMutet,
    getActionsEprofileKorabbiMutet: state => state.actionsEprofileKorabbiMutet,
    getRowActionsEprofileKorabbiMutet: state => state.rowActionsEprofileKorabbiMutet,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileKorabbiMutet: state => state.formIsOpen,
    isGridOpenEprofileKorabbiMutet: state => state.gridIsOpen
}
